export const routes = (parentName) => {
  return [
    {
      path: "surgery",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Surgery`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Surgery-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "special",
          name: `${parentName}-Surgery-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Surgery-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Surgery-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Surgery-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
